import { render, staticRenderFns } from "./InfoTab_last.vue?vue&type=template&id=32a9d1ae&scoped=true&"
import script from "./InfoTab_last.vue?vue&type=script&lang=js&"
export * from "./InfoTab_last.vue?vue&type=script&lang=js&"
import style0 from "./InfoTab_last.vue?vue&type=style&index=0&id=32a9d1ae&scoped=true&lang=css&"
import style1 from "./InfoTab_last.vue?vue&type=style&index=1&id=32a9d1ae&scoped=true&lang=css&"
import style2 from "./InfoTab_last.vue?vue&type=style&index=2&id=32a9d1ae&scoped=true&lang=css&"
import style3 from "./InfoTab_last.vue?vue&type=style&index=3&id=32a9d1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a9d1ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VCarousel,VCarouselItem,VCol,VDialog,VDivider,VIcon,VImg,VProgressCircular,VProgressLinear,VRow,VSelect,VSheet,VSpacer,VTextField})
